import React, { useEffect } from 'react';
import iconPatternThree from '../../../images/perform-2023-pattern3.svg';
import iconPatternFour from '../../../images/perform-2023-pattern4.svg';
import iconPatternFive from '../../../images/perform-2023-pattern5.svg';

const Perform2023VideoSection = ({ data }) => {

    useEffect(() => {
        if (data.perform23VideoSectionVideoId) {
            var scriptOne = document.createElement('script');
            scriptOne.src = '//fast.wistia.com/embed/medias/' + data.postEventIntroFormVideo + '.jsonp';
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }
    }, []);

    return (
        <div className="cp-perform2023Video">
            <div className="l--absolute l-absoluteThree">
                <img src={iconPatternThree} alt="" />
            </div>
            <div className="l--absolute l-absoluteFour">
                <img src={iconPatternFour} alt="" />
            </div>
            <div className="l--absolute l-absoluteFive">
                <img src={iconPatternFive} alt="" />
            </div>
            <div className="cp-perform2023Video__inner l--flex" data-aos="fade-up">
                <div className="l-videoSectionContent">
                    {data.perform23VideoSectionHeader &&
                        <h2>{data.perform23VideoSectionHeader}</h2>
                    }
                    {data.perform23VideoSectionTeaser &&
                        <div dangerouslySetInnerHTML={{ __html: data.perform23VideoSectionTeaser }} />
                    }
                    {data.perform23VideoSectionHeaderCta &&
                        <div className="l-buttonWrap">
                            <a className="l-button" href={data.perform23VideoSectionHeaderCta.url} target={data.perform23VideoSectionHeaderCta.target}>{data.perform23VideoSectionHeaderCta.title}</a>
                        </div>
                    }
                </div>
                {data.perform23VideoSectionVideoId &&
                    <div className="l-embedWrap">
                        <div className="l-embedWrap__inner">
                            <div className={`wistia_embed wistia_async_${data.perform23VideoSectionVideoId}`}>&nbsp;</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
export default Perform2023VideoSection;

